import React, { FC } from 'react';
import classes from '../../styles/NewTable.module.css';

const TableNoContent: FC<{ colSpan: number; message?: string,style?:React.CSSProperties }> = ({ colSpan, message = 'No items found',style }) => {
  return (
    <tr style={style}>
      <td colSpan={colSpan} className={classes.loaderRow} style={{ textAlign: 'center' }}>
        {message}
      </td>
    </tr>
  );
};

export default TableNoContent;
